import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Btn, StatusPanel } from '../components/design-system';

const NewsletterRemove: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');

  const remove = useCallback(async () => {
    if (!token) {
      setStatus('error');
      setMessage('Invalid removal link.');
      return;
    }
    setStatus('loading');
    setMessage('');
    try {
      const res = await fetch(`/api/newsletter/remove/${token}`, { method: 'POST' });
      if (!res.ok) throw new Error('Failed to remove subscription');
      setStatus('success');
      setMessage("Your subscription has been removed. We're sorry to see you go.");
      setTimeout(() => navigate('/'), 3000);
    } catch {
      setStatus('error');
      setMessage('Failed to remove subscription. The link may be invalid or expired.');
    }
  }, [token, navigate]);

  useEffect(() => {
    remove();
  }, [remove]);

  return (
    <StatusPanel title="newsletter · remove" status={status} message={message}>
      {status !== 'loading' && (
        <div style={{ marginTop: 20, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          {status === 'error' && (
            <Btn variant="ghost" onClick={remove}>
              try again
            </Btn>
          )}
          <Btn variant="primary" to="/">
            back to home
          </Btn>
        </div>
      )}
    </StatusPanel>
  );
};

export default NewsletterRemove;
